import React, { Component } from 'react';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
// import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { hide } from 'store/modules/modal';

export class SetToneNumberDialog extends Component {
  state = {
    toneId: this.props.tone.toneId || '',
  };

  render() {
    const { opened, dispatch, handleOk } = this.props;

    return (
      <div>
        <Dialog open={opened} onClose={() => dispatch(hide())}>
          <DialogTitle>Set Tone</DialogTitle>
          <DialogContent>
            <TextField
              margin="dense"
              id="toneNumber"
              label="Tone Number"
              type="number"
              fullWidth
              autoFocus
              value={this.state.toneId}
              onChange={event => {
                this.setState({ toneId: event.target.value });
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                dispatch(hide());
              }}
              color="secondary"
            >
              CANCEL
            </Button>
            <Button
              onClick={() => {
                handleOk(this.state.toneId);
                dispatch(hide());
              }}
              color="primary"
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    opened: state.modal.opened,
  };
};

export default connect(mapStateToProps)(SetToneNumberDialog);
